import React from 'react'
import { motion, AnimatePresence } from 'framer-motion';
import {FaUserTie,FaHandPointRight,FaRegCheckCircle} from "react-icons/fa";
import { TbArrowBigDownLinesFilled, TbCertificate } from "react-icons/tb";
import Benifits from './RegistrationCard/Benifits';

const RegistrationCard = ({landingPage,bonuses,handleShowForm,registeredCount,timer,nextSession,gradientClass,bgColor,textColor,bgShadow,textShadow}) => {
  return (
    <>
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-100">
            {/* Header */}
            <div className={`${gradientClass} p-4 text-white text-center`}>
            <h3 className="text-xl font-bold">{landingPage.seatGrabText}</h3>
            <p className="text-purple-100">{landingPage.buttonSubheadlineText}</p>
            </div>

            {/* Timer Section */}
            <div className="p-6 border-b border-gray-100">
            <p className="text-lg text-gray-700 font-medium text-center mb-4">
                Next session starts at <span className={`${textColor} font-bold`}>{nextSession}</span>
            </p>
            
            <div className="flex justify-center space-x-3 mb-6">
                {timer.split(' ').filter((_, i) => i % 2 === 0).map((time, index) => (
                <motion.div 
                    key={index}
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ 
                    repeat: Infinity, 
                    repeatType: "reverse", 
                    duration: 1.5,
                    delay: index * 0.2
                    }}
                    className={`${gradientClass} text-white w-16 h-16 flex flex-col items-center justify-center rounded-lg text-xl shadow`}
                >
                    <span className="text-sm font-light">{timer.split(' ')[index*2 + 1]}</span>
                    <span className="font-bold">{time}</span>
                </motion.div>
                ))}
            </div>

            <div className={`${bgShadow} rounded-lg p-4 mb-6`}>
                <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">Seats filled:</span>
                <span className={`text-sm font-bold ${textColor}`}>{Math.min(registeredCount, 95)}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div 
                    className={`${bgColor} h-2.5 rounded-full `}
                    style={{ width: `${Math.min(registeredCount, 95)}%` }}
                ></div>
                </div>
            </div>
            </div>

            {/* Benefits List */}
            <Benifits textColor={textColor} textShadow={textShadow} bonuses={bonuses} />

            {/* CTA Section */}
            <div className="p-6">
            <motion.div 
                animate={{ y: [0, 5, 0] }}
                transition={{ repeat: Infinity, duration: 1.5 }}
                className='flex justify-center mb-6'
            >
                <TbArrowBigDownLinesFilled className={`text-4xl ${textColor}`} />
            </motion.div>
            
            <motion.button
            onClick={handleShowForm}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={`w-full ${gradientClass} text-white py-4 px-6 rounded-lg font-bold flex flex-col items-center justify-center shadow-lg hover:shadow-xl transition-all`}
            >
                <div className='flex items-center'>
                    <FaHandPointRight className="mr-2 text-xl" />
                    <span className="text-lg">
                    {landingPage.buttonHeadlineText || "Register Now - 100% FREE"}
                    </span>
                </div>
                <span className="text-sm font-medium opacity-80 mt-1">
                    {landingPage.buttonSubheadlineText || "Limited Seats Available!"}
                </span>
            </motion.button>

            <div className="mt-4 flex items-center justify-center">
                <div className="flex items-center text-sm text-gray-500">
                <FaUserTie className="mr-2" />
                <span>Perfect for beginners & experts</span>
                </div>
            </div>
            </div>
        </div>
    </>
  )
}

export default RegistrationCard
